import { useQuery } from "@tanstack/react-query";
import { roleApi } from "@repo/api";
import { queryKeys } from "../../queries/queryKeys";

export const useRoles = (activeOnly = true) => {
  return useQuery({
    queryKey: queryKeys.roles.list(activeOnly),
    queryFn: () => roleApi.getRoles(activeOnly),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
